import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Company } from 'src/app/models/company.model';
import { Plant } from 'src/app/models/plant.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { PlantsService } from 'src/app/services/plants/plants.service';

@Component({
  selector: 'app-add-plant',
  templateUrl: './add-plant.component.html',
  styleUrls: ['./add-plant.component.scss'],
})
export class AddPlantComponent {
  [x: string]: any;
  files: string[] = [];
 
  @ViewChild('input', { static: false }) myInputVariable: ElementRef;

  constructor(
    private router: Router,
    private plantsService: PlantsService,
    private companysService: CompanysService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder
  ) {}

  submitted = false;
  AddPlantForm!: FormGroup;
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  addPlantRequest: Plant = new Plant();
  companys: Company[] = [];
  TypeError: boolean = false;
  CompanyIdError: boolean = false;
  RegionError: boolean = false;

  ngOnInit(): void {
    this.addPlantRequest.Type = null;
    this.addPlantRequest.CompanyId = null;
    this.addPlantRequest.Region = null;
    this.companysService.getAllCompanys().subscribe({
      next: (companys) => {
        this.companys = companys;
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.AddPlantForm = this.formBuilder.group({
      Location: ['', Validators.required],
      Name: ['', Validators.required],
    });
  }

  validation() {
    let isValid = true;
  
    if (this.addPlantRequest.Type == null) {
      this.TypeError = true;
      isValid = false;
    } else {
      this.TypeError = false;
    }
  
    if (this.addPlantRequest.CompanyId == null) {
      this.CompanyError = true;
      isValid = false;
    } else {
      this.CompanyError = false;
    }
  
    if (this.addPlantRequest.Region == null) {
      this.RegionError = true;
      isValid = false;
    } else {
      this.RegionError = false;
    }
    
    return isValid;
  }
  

  addPlant() {
    this.submitted = true;
    this.validation();
    if (this.AddPlantForm.valid && this.validation()) {
      const dateNowISO = this.dateNow.toISOString();
      if (this.addPlantRequest.Type == 3) {
        this.addPlantRequest.Type = 0;
      }
      this.addPlantRequest.Location = this.AddPlantForm.value.Location;
      this.addPlantRequest.Name = this.AddPlantForm.value.Name;
      this.addPlantRequest.CreatedAt = dateNowISO;
      this.addPlantRequest.UpdatedAt = dateNowISO;
      this.plantsService.addPlant(this.addPlantRequest, this.files).subscribe({
        next: (Plant) => {
          this.plantsService.getAllPlant().subscribe(res => {

            this.plantsService.setPlants(res);          // Refresh dropdown list
            this.plantsService.setSelectedPlant(Plant.Id); // Select new plant

            var id = btoa(Plant.Id.toString());
            this.toastr.success('Plant Created Successfully.', 'Information');
            this.router.navigate(['/component/plants/edit/' + id]);
          });
          // var id = btoa(Plant.Id.toString());
          // this.toastr.success('Plant Created Successfully.', 'Information');
          // this.router.navigate(['/component/plants/edit/' + id]);
          
        },
        error: (response) => {
          if (response.error.length > 0) {
            this.toastr.error(response.error, 'Error');
          } else {
            this.toastr.error('Error While Creating Plant.', 'Error');
          }
        },
      });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }

    
  }
  addFile(files) {
    if (files.length === 0) {
      return;
    }
    for (let file of files) {
      var parts = file.name.split('.');
      if (parts.length <= 1) {
        console.log('File ' + file.name + ' is not valid file');
      } else {
        this.files.push(file);
      }
    }
    this.myInputVariable.nativeElement.value = '';
  }

  
}
